export default __webpack_public_path__ + "static/media/KLO.177d0d0c.png";